import Http from './base-http'

class Process extends Http {
  importFile(data) {
    return this.client.post(`company/import`, data)
  }
  importScheduleSimple(id ,data) {
    return this.client.post(`workschedule/import/company/${id}`, data)
  }

  applyOvertimeRule(data) {
    return this.client.post(`company/` + data.companyId + '/overtimetemplate/' + data.rule)
  }
}

const process = new Process({
  modelUrlPrefix : 'process/'
})

export default process
